import { keyBy } from 'lodash-es';
import { EncounterTypeEligibilityStatus } from '../enums/encounter-type-eligibility-status.enum';

export const EncounterTypeEligibilityStatusOptions = [
  { value: EncounterTypeEligibilityStatus.new, display: 'New' },
  { value: EncounterTypeEligibilityStatus.eligible, display: 'Eligible' },
  { value: EncounterTypeEligibilityStatus.ineligible, display: 'Ineligible' },
];

export const keyedEncounterTypeEligibilityStatusOptions =
  keyBy(EncounterTypeEligibilityStatusOptions, 'value');
